var sv = {
  "Add Quantity Breaks to your product page": "Lägg till mängdrabatter på din produktsida",
  "Add Upsell.com to your ": "Lägg till Upsell.com på din ",
  "Add to cart click": "Klick på Lägg i varukorg",
  "All time": "Hela tiden",
  "and select": "och välj",
  "button": "-knappen",
  "Cart drawer page": "Varukorgslåda-sida",
  "Cart page": "Varukorg-sida",
  "Check status": "Kontrollera status",
  "Checkout page": "Kassa-sida",
  "Checkout click": "Klick på Kassa",
  "Click": "Klicka på",
  "Click on": "Klicka på",
  "Click the": "Klicka på",
  "Custom slot": "Anpassad plats",
  "Custom slots": "Anpassade platser",
  "Custom Slots": "Anpassade platser",
  "Enable in theme editor": "Aktivera i temaeditorn",
  "contact support.": "kontakta supporten.",
  "from the right sidebar": "från den högra sidopanelen",
  "Go to App Embeds": "Gå till appinbäddningar",
  "Go to your Cart drawer page": "Gå till din Varukorgslåda-sida",
  "Go to your Cart page": "Gå till din Varukorg-sida",
  "Go to your Checkout page": "Gå till din Kassa-sida",
  "Go to your Order status page": "Gå till din Orderstatus-sida",
  "Go to your Post purchase page": "Gå till din Sida efter köp",
  "Go to your Product page": "Gå till din Produktsida",
  "Go to your Thank you page": "Gå till din Tack-sida",
  "items": "artiklar",
  "in the left sidebar": "i den vänstra sidopanelen",
  "Last 12 months": "Senaste 12 månaderna",
  "Last 30 days": "Senaste 30 dagarna",
  "Last 365 days": "Senaste 365 dagarna",
  "Last 7 days": "Senaste 7 dagarna",
  "Last 90 days": "Senaste 90 dagarna",
  "Last month": "Förra månaden",
  "Last year": "Förra året",
  "Make sure": "Se till att",
  "Need assistance? Contact our support team for help.": "Behöver du hjälp? Kontakta vårt supportteam.",
  "Order status page": "Orderstatus-sida",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "Vår app genomgår just nu lite magi för att förbättra din upplevelse.",
  "Post purchase page": "Sida efter köp",
  "Product page": "Produktsida",
  "Save": "Spara",
  "Scroll to the bottom and select": "Scrolla längst ner och välj",
  "Select": "Välj",
  "Success. Please continue.": "Lyckades. Vänligen fortsätt.",
  "Thank you page": "Tack-sida",
  "The Upsell.com team.": "Upsell.com-teamet.",
  "The Upsell.com widget is not placed on ": "Upsell.com-widgeten är inte placerad på ",
  ". Please follow the steps above or ": ". Vänligen följ stegen ovan eller ",
  "Today": "Idag",
  "toggle is on": "reglaget är på",
  "Total": "Totalt",
  "under": "under",
  "We apologize for any inconvenience caused,": "Vi ber om ursäkt för eventuella besvär,",
  "We apologize for any inconvenience caused.": "Vi ber om ursäkt för eventuella besvär.",
  "We'll be done in a few minutes!": "Vi är klara om några minuter!",
  "We're improving our services!": "Vi förbättrar våra tjänster!",
  "Widget already added": "Widget redan tillagd",
  "Yesterday": "Igår",
  "You enabled the widget in your online store but didn't save it in the Upsell editor": "Du aktiverade widgeten i din webbutik men sparade den inte i Upsell-redigeraren",
  "You placed the widget on the ": "Du placerade widgeten på ",
  ", but you didn't save it in Shopify editor. Please go back to ": ", men du sparade den inte i Shopify-redigeraren. Gå tillbaka till ",
  " and save the changes.": " och spara ändringarna."
};

export { sv as default };
//# sourceMappingURL=sv.json.js.map
